import React, {useEffect, useState} from 'react';
import {Card, Checkbox, Flex} from "antd";
import style from "./CitiesCard.module.scss";
import {StyledCard} from "./CitiesCard.styled";
import { FaChevronLeft } from "react-icons/fa6";
import {useNavigate} from "react-router-dom";
import {AllCitiesCardProps, CitiesCardProps, ProvinceCardProps} from "../../../models";

const AllCitiesCard = ({title,onCityClick,citiesId,citiesList} :AllCitiesCardProps) => {
    const navigate =useNavigate()
    const [isChecked, setIsChecked] = useState<boolean>(false)
    useEffect(() => {
        setIsChecked(citiesId?.length === citiesList?.length)
    }, [citiesId]);
    return (
        <StyledCard  >
            <Flex justify={"space-between"} align={"center"}>
                <span> {title} </span>
                <Checkbox checked={isChecked}
                          onClick={(value:any) => {
                              const checked = value.target.checked
                              onCityClick(checked)
                          }}/>

            </Flex>
        </StyledCard>
    )

};

export default AllCitiesCard;
